"use client";

import React from "react";
import { useTranslations } from "next-intl";
import { contactInfo } from "@/lib/contacts";

interface Props {
	props: string;
	slogan?: string;
}

const TopNavOne: React.FC<Props> = ({ props }) => {
	const t = useTranslations();

	return (
		<div
			className={`top-nav border-brand-ink/6 fixed top-0 z-[101] flex h-[32px] w-full items-center border-b bg-brand-tint text-[11px] tracking-[0.04em] text-brand-ink/60 ${props}`}
		>
			<div className="mx-auto flex w-full max-w-[1580px] items-center justify-between px-6 sm:px-10 lg:px-16">
				<a
					href={`mailto:${contactInfo.email}`}
					className="flex items-center gap-2 font-body transition-colors duration-200 hover:text-brand-ink"
				>
					<i className="ri-mail-line text-brand-fg/55 text-[12px]" />
					{contactInfo.email}
				</a>

				<span className="hidden font-body text-[10px] uppercase tracking-[0.16em] text-brand-ink/40 sm:block">
					{t("home.slogan")}
				</span>

				<div className="hidden items-center gap-5 md:flex">
					{contactInfo.phone && (
						<a
							href={`tel:${contactInfo.phone}`}
							className="flex items-center gap-2 font-body transition-colors duration-200 hover:text-brand-ink"
						>
							<i className="ri-phone-line text-brand-fg/55 text-[12px]" />
							{contactInfo.phone}
						</a>
					)}
					{contactInfo.whatsapp && (
						<a
							href={`https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, "")}`}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-2 font-body transition-colors duration-200 hover:text-brand-ink"
						>
							<i className="ri-whatsapp-line text-brand-fg/55 text-[12px]" />
							{contactInfo.whatsapp}
						</a>
					)}
				</div>
			</div>
		</div>
	);
};

export default TopNavOne;
